module.exports = __webpack_public_path__ + "img/myposition_wf_리오넬 메시.a5559b8d.png";